module.exports = __webpack_public_path__ + "static/media/Verilog.ac4ca959.png";